import { Typography } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import MuiLink from '@mui/material/Link';
import FeatherIcon from 'feather-icons-react';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppDataContext } from '../../components/context/app-data-context';

const AnalyticsBreadcrumb = () => {
    return [
        <MuiLink key="analytics" variant="body2" underline="hover" as={Link} disabled={true} to={"/"} className="disabled" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography component="span" display="inline-flex" marginBottom={.25}><FeatherIcon icon="home" size={16} /></Typography>Analytics
        </MuiLink>
    ];
};

const SettingsBreadcrumb = ({ isCurrent = true }) => {
    return [
        <MuiLink key="settings" variant="body2" underline="hover" disabled={isCurrent} className={isCurrent ? "disabled" : ""} to={"/companies"} as={Link} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography component="span" display="inline-flex"><FeatherIcon icon="settings" size={16} /></Typography>Settings
        </MuiLink>
    ];
};

const CompaniesBreadcrumb = ({ isCurrent = true }) => {
    return [
        ...SettingsBreadcrumb({ isCurrent: false }),
        <MuiLink key="companies" variant="body2" underline="hover" as={Link} disabled={isCurrent} to={"/companies"} className={isCurrent ? "disabled" : ""}>
            Companies
        </MuiLink>
    ];
};

const EditCompanyBreadcrumb = () => {
    return [
        ...CompaniesBreadcrumb({ isCurrent: false }),
        <MuiLink key="edit-company" variant="body2" underline="hover" as={Link} disabled={true} to={"/edit-company"} className="disabled">
            Edit Company
        </MuiLink>
    ];
};

const UsersBreadcrumb = () => {
    return [
        ...SettingsBreadcrumb({ isCurrent: false }),
        <MuiLink key="users" variant="body2" underline="hover" as={Link} disabled={true} to={"/users"} className="disabled">
            User Setup
        </MuiLink>
    ];
};

const AdminInsightsBreadcrumb = () => {
    return [
        ...SettingsBreadcrumb({ isCurrent: false }),
        <MuiLink key="insight-admin" variant="body2" underline="hover" as={Link} disabled={true} to={"/insight-admin"} className="disabled">
            Insight Admin
        </MuiLink>
    ];
};

const CampaignsBreadcrumb = ({ isCurrent = true }) => {
    return [
        <MuiLink key="campaigns" variant="body2" underline="hover" as={Link} disabled={isCurrent} to={"/campaigns"} className={isCurrent ? "disabled" : ""} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography component="span" display="inline-flex"><FeatherIcon icon="message-square" size={16} /></Typography>Campaigns
        </MuiLink>
    ];
};

const CampaignBreadcrumb = ({ isCurrent = true }) => {
    const { campaign } = useContext(AppDataContext);
    const campaignId = campaign.id;
    const campaignName = campaign.name || "Campaign";

    return [
        ...CampaignsBreadcrumb({ isCurrent: false }),
        <MuiLink key="campaign" variant="body2" underline="hover" as={Link} disabled={isCurrent} to={`/campaign?id=${campaignId}`} className={isCurrent ? "disabled" : ""}>
            {campaignName}
        </MuiLink>
    ];
};

const ConversationBreadcrumb = () => {
    return [
        ...CampaignBreadcrumb({ isCurrent: false }),
        <MuiLink key="conversation" variant="body2" underline="hover" as={Link} disabled={true} className="disabled">
            Conversation
        </MuiLink>
    ];
};

const PlaylistsBreadcrumb = () => {
    return [
        <MuiLink key="playlists" variant="body2" underline="hover" as={Link} disabled={true} to={"/playlists"} className="disabled" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography component="span" display="inline-flex"><FeatherIcon icon="play-circle" size={16} /></Typography>Playlists
        </MuiLink>
    ];
};

const AlertsBreadcrumb = () => {
    return [
        <MuiLink key="alerts" variant="body2" underline="hover" as={Link} disabled={true} to={"/alerts"} className="disabled" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography component="span" display="inline-flex"><FeatherIcon icon="bell" size={16} /></Typography>Alerts
        </MuiLink>
    ];
};

const InsightsBreadcrumb = ({ isCurrent = true }) => {
    return [
        <MuiLink key="insights" variant="body2" underline="hover" as={Link} disabled={isCurrent} to={"/insights"} className={isCurrent ? "disabled" : ""} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography component="span" display="inline-flex"><FeatherIcon icon="loader" size={16} /></Typography>Insights
        </MuiLink>
    ];
};

const InsightBreadcrumb = () => {
    const { insightName } = useContext(AppDataContext);

    return [
        ...InsightsBreadcrumb({ isCurrent: false }),
        <MuiLink key="insight-phrases" variant="body2" underline="hover" as={Link} disabled={true} to={"/insight-phrases"} className="disabled">
            {insightName}
        </MuiLink>
    ];
};

const ProfileBreadcrumb = () => {
    return [
        <MuiLink key="profile" variant="body2" underline="hover" as={Link} disabled={true} to={"/profile"} className="disabled" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography component="span" display="inline-flex"><FeatherIcon icon="user" size={16} /></Typography>Profile
        </MuiLink>
    ];
};

const SupportBreadcrumb = () => {
    return [
        <MuiLink key="support" variant="body2" underline="hover" as={Link} disabled={true} to={"/support"} className="disabled" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography component="span" display="inline-flex"><FeatherIcon icon="headphones" size={16} /></Typography>Support
        </MuiLink>
    ];
};

const PrivacyBreadcrumb = () => {
    return [
        <MuiLink key="privacy" variant="body2" underline="hover" as={Link} disabled={true} to={"/privacy"} className="disabled" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography component="span" display="inline-flex"><FeatherIcon icon="shield" size={16} /></Typography>Privacy
        </MuiLink>
    ];
};

const TermsBreadcrumb = () => {
    return [
        <MuiLink key="privacy" variant="body2" underline="hover" as={Link} disabled={true} to={"/terms"} className="disabled" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography component="span" display="inline-flex"><FeatherIcon icon="file-text" size={16} /></Typography>Terms
        </MuiLink>
    ];
};

const breadcrumbMap = {
    "/": AnalyticsBreadcrumb,
    "/campaigns": CampaignsBreadcrumb,
    "/campaign": CampaignBreadcrumb,
    "/conversation": ConversationBreadcrumb,
    "/playlists": PlaylistsBreadcrumb,
    "/insights": InsightsBreadcrumb,
    "/insight-phrases": InsightBreadcrumb,
    "/alerts": AlertsBreadcrumb,
    "/companies": CompaniesBreadcrumb,
    "/users": UsersBreadcrumb,
    "/insight-admin": AdminInsightsBreadcrumb,
    "/edit-company": EditCompanyBreadcrumb,
    "/profile": ProfileBreadcrumb,
    "/privacy": PrivacyBreadcrumb,
    "/support": SupportBreadcrumb,
    "/terms": TermsBreadcrumb,
};

const GetBreadcrumb = ({ currentPath }) => {
    const BreadcrumbComponent = breadcrumbMap[currentPath];
    return BreadcrumbComponent ? [...BreadcrumbComponent({ isCurrent: true })] : [];
};

function AppBreadcrumbs({ currentPath }) {
    return (
        <Breadcrumbs maxItems={3} aria-label="breadcrumb" sx={{ paddingTop: .25, display: {xs: 'none', sm: 'block'} }} className="breadcrumbs">
            {GetBreadcrumb({ currentPath }).map((breadcrumb, index) => (
                <React.Fragment key={index}>{breadcrumb}</React.Fragment>
            ))}
        </Breadcrumbs>
    );
}

export default AppBreadcrumbs;